/**
 * HACK: Prevent Redux Form from deleting field keys when value is empty string.
 * We don't want this, because it means we are unable to clear inquiry field
 * values in optional form controls when PATCHing.
 * @see https://github.com/redux-form/redux-form/blob/master/src/createReducer.js#L306
 */
export const parseEmptyStringToNull = (value: string): string | null =>
  value === '' ? null : value;
